<template>
  <div class="relative w-full">
    <RevRadio
      :id
      :class="[$style.radio]"
      :model-value="isSelected"
      :value="id"
      variant="full"
      @click="handleClick"
    >
      <template #label>
        <div class="space-y-8">
          <span class="body-1-bold">{{ offer.title }}</span>

          <InsurancePrice
            v-if="offer.price && offer.price.amount !== '0.00'"
            :is-monthly="offer.isMonthly"
            :price="offer.price"
          />
        </div>
      </template>

      <template #description>
        <RevDivider
          class="relative -inset-x-[38px] mb-16 mt-8 w-[calc(100%+38px)]"
        />

        <ul class="relative -inset-x-8 mt-8 space-y-8">
          <li
            v-for="benefit in offer.benefits.short"
            :key="benefit"
            class="flex items-center"
          >
            <IconCheckSmall class="shrink-0 self-start" /> {{ benefit }}
          </li>
        </ul>
      </template>
    </RevRadio>
  </div>
</template>

<script setup lang="ts">
import type { InsuranceOffer } from '@backmarket/http-api'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevDivider } from '@ds/components/Divider'
import { RevRadio } from '@ds/components/Radio'
import { IconCheckSmall } from '@ds/icons/IconCheckSmall'

import InsurancePrice from '../InsurancePrice/InsurancePrice.vue'

const { trackClick } = useTracking()

const props = defineProps<{
  id: string
  offer: InsuranceOffer
  isSelected: boolean
  trackingZone: string
}>()

const emit = defineEmits(['select', 'remove'])

function handleClick() {
  trackClick({
    name: props.offer.title,
    value: props.offer.isMonthly ? 'monthly' : 'upfront',
    zone: props.trackingZone,
  })

  emit(props.isSelected ? 'remove' : 'select')
}
</script>

<style lang="css" module>
.radio {
  @apply h-full;
}

.radio > label {
  @apply h-full;
  @apply border-l-6;
  @apply border-l-static-default-mid;
}
</style>
